<template>
  <div id="app">
    <components :is="layout">
      <router-view />
    </components>
  </div>

</template>

<script>

import landing from "./layout/Landing";
import auth from "./layout/Auth";
import dashboard from "./layout/Dashboard";
import diklat from "./layout/diklat";

export default {
  name: "App",
  components: { landing, auth, dashboard , diklat},
  computed: {
    layout() {
      return (this.$route.meta.layout || landing) ;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue